import {Directive} from "@angular/core";
import {NgControlStatus} from "@angular/forms";

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: "[ngModel]:not([rfNoValidationClasses]),[formControl]:not([rfNoValidationClasses]),[formControlName]:not([rfNoValidationClasses])",
  host: {
    "[class.is-valid]": "isTouched && isDirty && isValid",
    "[class.is-invalid]": "isTouched && isDirty && isInvalid",
  },
})
export class BootstrapFormControlValidationClasses extends NgControlStatus {
}
